import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Hero from "../Components/Hero";
import WhyChoose from "../Components/WhyChoose";
import Application from "../Components/Application";
import Cta from "../Components/Cta";
import { qualities } from "../Data";

import aboutImg1 from '../Images/home-about-1.webp'
import aboutImg2 from '../Images/home-about-2.webp'
import aboutImg3 from '../Images/home-about-3.webp'
import centerIcon from '../Images/home-about-icon-4.png'
import Testimonials from "../Components/Testimonial";
import Products from "../Components/Products";
import CalculatorSection from "../Components/CalculatorSection";
import Production from "../Components/Production";
import Export from "../Components/Export";

const Home=()=>{

     useEffect(() => {
    document.title =
      "Best Tile Adhesive Manufacturer in Gujarat | VigoFlex";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "High-performance tile adhesives by VigoFlex for strong, durable bonding across interior and exterior surfaces. Reliable solutions for every project."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://vigoflex.in/");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Best Tile Adhesive Manufacturer in Gujarat | VigoFlex"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "High-performance tile adhesives by VigoFlex for strong, durable bonding across interior and exterior surfaces. Reliable solutions for every project."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://vigoflex.in/");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://vigoflex.in/files/home-image.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Best Tile Adhesive Manufacturer in Gujarat | VigoFlex"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "High-performance tile adhesives by VigoFlex for strong, durable bonding across interior and exterior surfaces. Reliable solutions for every project."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://vigoflex.in/files/home-image.webp"
    );
  }
  }, [])

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: { y: 40, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Cards = tile placement feel
const cardStagger = {
  hidden: { y: 30, opacity: 0, scale: 0.95 },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 120,
      damping: 12,
    },
  },
};

// Right images (material stacking)
const imageReveal = {
  hidden: { scale: 1.1, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

// Center card (anchor/bond)
const centerCardAnim = {
  hidden: { scale: 0.7, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 180,
      damping: 10,
    },
  },
};

    return(
        <>

        {/**HERO SECTION */}
        <Hero />

        {/**ABOUT US SECTION */}

<section className="about-section">
  <div className="container">

    {/* LEFT SIDE */}
    <motion.div
      className="about-left"
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
    >
      <motion.h3 className="section-subheading" variants={fadeUp}>
        About VigoFlex
      </motion.h3>

      <motion.h2 className="section-heading" variants={fadeUp}>
        Tile Adhesives You Can Trust for Every Project
      </motion.h2>

      <motion.p className="section-text" variants={fadeUp}>
      VigoFlex offers a comprehensive range of high-performance tile adhesives formulated to meet diverse tiling requirements—from interior floors and walls to demanding exterior and high-traffic applications. Each product is carefully engineered using advanced formulations to ensure superior bonding strength, long-lasting durability, and reliable performance across various surfaces and conditions. Designed with both professionals and contractors in mind, VigoFlex adhesives deliver consistent, hassle-free results on-site, helping achieve precise finishes, enhanced structural integrity, and long-term peace of mind for every project.
      </motion.p>

      {/* QUALITIES */}
      <motion.div className="qualities-grid" variants={container}>
        {qualities.map((item, i) => (
          <motion.div
            className="qualities-card"
            key={i}
            variants={cardStagger}
            whileHover={{ scale: 1.05 }}
          >
            <img src={item.icon} alt={`${item.title} | VigoFlex`} />
            <h4 className="card-heading">{item.title}</h4>
          </motion.div>
        ))}
      </motion.div>

      {/* BUTTONS */}
      <motion.div className="home-about-btns" variants={fadeUp}>
        <motion.a
          className="btn btn-primary"
          whileTap={{ scale: 0.92 }}
          whileHover={{ scale: 1.05 }}
          href="/about-us"
        >
          Know More
        </motion.a>

        <motion.a
        href="#products"
          className="btn btn-outline"
          whileTap={{ scale: 0.92 }}
          whileHover={{ scale: 1.05 }}
        >
          Explore Products
        </motion.a>
      </motion.div>
    </motion.div>

    {/* RIGHT SIDE */}
    <motion.div
      className="about-right"
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {/* CENTER CARD */}
      <motion.div className="center-card" variants={centerCardAnim}>
        <img src={centerIcon} alt="Perfect Bond for Every Project | VigoFlex" />
        <h4>Perfect Bond for Every Project</h4>
      </motion.div>

      {/* DOTS (enhanced bonding feel) */}
      <motion.div
        className="about-dots-1 about-dots"
        animate={{
          scale: [1, 1.4, 1],
          opacity: [0.5, 1, 0.5],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <motion.div
        className="about-dots-2 about-dots"
        animate={{
          scale: [1, 1.4, 1],
          opacity: [0.5, 1, 0.5],
        }}
        transition={{
          duration: 2,
          delay: 0.5,
          repeat: Infinity,
        }}
      />

      {/* IMAGES */}
      <motion.img
        src={aboutImg1}
        alt=" Tile Adhesives You Can Trust for Every Project 1 | VigoFlex"
        variants={imageReveal}
      />

      <div className="about-img-col">
        <motion.img
          src={aboutImg2}
          alt=" Tile Adhesives You Can Trust for Every Project 2 | VigoFlex"
          variants={imageReveal}
        />
        <motion.img
          src={aboutImg3}
          alt=" Tile Adhesives You Can Trust for Every Project 3 | VigoFlex"
          variants={imageReveal}
        />
      </div>
    </motion.div>

  </div>
</section>

        {/**WHY CHOOSE US SECTION */}
        <WhyChoose />

        {/**PRODUCTION SECTION */}
        <div className="home">
<Production/>
</div>
        {/**PRODUCTS GRID */}
        <Products />

        {/**APPLICATIONS SECTION */}
        <Application />

        {/**EXPORT & PACKAGING SECTION */}
        <Export />

        {/**CALCULATOR SECTION */}
        <CalculatorSection />

         {/**TESTIMONIALS SECTION */}
        <Testimonials />

        {/**CTA SECTION */}
        <Cta />

        </>
    )
}
export default Home;